import request from '@/utils/axios.js'

// 便捷青岛发送验证码
export function apiSendCode (data) {
  return request({
    url: '/usercenter/userAPI/user/captcha/send',
    method: 'post',
    data: data
  })
}

// 便捷青岛注册
export function apiRegister (data) {
  return request({
    // url: '/userAPI/app/user/register/open/H5',
    url: '/usercenter/userAPI/user/register',
    method: 'post',
    data: data
  })
}

// 便捷青岛金领财富获取连接
export function getBjLink (data) {
  return request({
    url: 'https://api.qingdaogxt.com/user/mobileAPI/goFunCtlPage',
    method: 'post',
    data: data
  })
}

// 隧e通金领财富获取连接
export function getSeLink (data) {
  return request({
    url: 'https://api.qingdaogxt.com/user/mobileAPI/goFunCtlPage',
    method: 'post',
    data: data
  })
}

// 根据id获取服务协议内容
export function agreementDetail (id) {
  return request({
    url: `/manageApp/openAPI/agreement/${id}`,
    method: 'get'
  })
}
